var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-slide"},[_c('img',{staticClass:"image-slide__img",attrs:{"src":_vm.src,"loading":"lazy","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }